import React from 'react';

const Heading = ({
  as: Component = 'h2',
  className = '',
  eyebrow,
  children,
  align = 'left',
}) => {
  const classes = ['c-heading', `c-heading--${align}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {eyebrow ? <p className="c-heading__eyebrow">{eyebrow}</p> : null}
      <Component className="c-heading__title">{children}</Component>
    </div>
  );
};

export default Heading;
